import { AUTH_BASE_URL } from "./APIConstants";

export const USER_INFO = "user_info";
export const JWT_TOKEN = process.env.REACT_APP_TOKEN_KEY;
export const REFRESH_TOKEN = process.env.REACT_APP_REF_TOKEN_KEY;
export const REFRESH_TOKEN_EXPIRY_TIME = "ref_token_expiry";

export const AUTH_LOGIN_URL = AUTH_BASE_URL + "/login";
export const AUTH_LOGOUT_URL = AUTH_BASE_URL + "/logout";

// Build the portal login URL with a `redirect` param pointing back to the page
// the user is currently on, so the portal can return them here after login.
// Uses the full current URL (including path + query) so deep links are preserved.
export const getLoginUrlWithRedirect = () => {
  const returnUrl = window.location.href;
  return `${AUTH_LOGIN_URL}?redirect=${encodeURIComponent(returnUrl)}`;
};

// Build the portal logout URL with a `redirect` param pointing back to the
// Integration site's home, so that after the user logs out and signs in again
// the portal returns them here rather than leaving them on the portal.
export const getLogoutUrlWithRedirect = () => {
  const returnUrl = window.location.origin;
  return `${AUTH_LOGOUT_URL}?redirect=${encodeURIComponent(returnUrl)}`;
};
